import { isSystemDark } from './isSystemDark';
import { loadTheme } from '../utils/loadTheme';
import { logUsage } from 'owa-analytics';
import { THEME_MODE_SYSTEM_DARK, THEME_MODE_SYSTEM_LIGHT } from '../constants/constants';
import type { ThemeMode } from '../schema/ThemeMode';

const logSystemTheme =
    false; /* Remove this flag on getting approval from privacy review team for logging system theme changes. */

export const changeSystemTheme = (themeMode: ThemeMode) => {
    loadTheme(themeMode);
    const isCurrentSystemDark = isSystemDark();
    const newAppearance = isCurrentSystemDark ? THEME_MODE_SYSTEM_DARK : THEME_MODE_SYSTEM_LIGHT;
    const prevAppearance = isCurrentSystemDark ? THEME_MODE_SYSTEM_LIGHT : THEME_MODE_SYSTEM_DARK;

    if (logSystemTheme) {
        logUsage('changeThemeMode', {
            prevVal: prevAppearance,
            newVal: newAppearance,
            source: 'System',
        });
    }
};
